/* @ngInject */
function ImageFactory($http, $rootScope) {
  class Image {
    constructor(data) {
      if (data) this.setData(data);
    }

    setData(data) {
      angular.extend(this, data);
    }

    static getResourceUrl() {
      return `${process.env.SERVER_URL}/api/secure/organization/${$rootScope.organization.slug}/images`;
    }

    static create(metadata) {
      return $http
        .post(Image.getResourceUrl(), metadata)
        .then((response) => new Image(response.data));
    }
  }

  return Image;
}

export default ImageFactory;
